var map = {
	"./decidim/avatar-multiuser.png": 29277,
	"./decidim/brands/google.svg": 28960,
	"./decidim/cc-badge.png": 39179,
	"./decidim/decidim-logo.svg": 19935,
	"./decidim/default-avatar.svg": 98099,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 91801,
	"./decidim/icons.svg": 58882,
	"./decidim/pattern.png": 33953,
	"./decidim/placeholder-card-g.svg": 30286,
	"./decidim/placeholder-card-l.svg": 33829,
	"./decidim/placeholder.jpg": 8532,
	"./decidim/remixicon.symbol.svg": 90806,
	"./decidim/vendor/leaflet/layers-2x.png": 20115,
	"./decidim/vendor/leaflet/layers.png": 91178,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 60111,
	"./decidim/vendor/leaflet/marker-icon.png": 37446,
	"./decidim/vendor/leaflet/marker-shadow.png": 87869,
	"./decidim/vendor/social-share-button/douban.svg": 69177,
	"./decidim/vendor/social-share-button/email.svg": 55066,
	"./decidim/vendor/social-share-button/facebook.svg": 88818,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 82462,
	"./decidim/vendor/social-share-button/hacker_news.svg": 99418,
	"./decidim/vendor/social-share-button/linkedin.svg": 97608,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 50049,
	"./decidim/vendor/social-share-button/pinterest.svg": 93028,
	"./decidim/vendor/social-share-button/reddit.svg": 69662,
	"./decidim/vendor/social-share-button/telegram.svg": 6847,
	"./decidim/vendor/social-share-button/tumblr.svg": 81468,
	"./decidim/vendor/social-share-button/twitter.svg": 66799,
	"./decidim/vendor/social-share-button/vkontakte.svg": 91981,
	"./decidim/vendor/social-share-button/wechat.svg": 76240,
	"./decidim/vendor/social-share-button/whatsapp.svg": 21584,
	"./decidim/vendor/social-share-button/x.svg": 54650,
	"./decidim/vendor/social-share-button/xing.svg": 43374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27096;